import type { Announcement } from '~/models'
import { announcementErrorHandbook } from '@/models'
import { HttpService } from '~/services/Http.service'
import { HttpErrorService } from '@/services/HttpError.service'

export class AnnouncementService {
  private endpoint = '/announcements'
  private httpErrorService: HttpErrorService<
    keyof typeof announcementErrorHandbook
  >

  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      announcementErrorHandbook,
      'announcement',
    )
  }

  async send(body: Announcement) {
    return await this.httpService
      .post(this.endpoint, {
        fetchConfig: {
          body,
        },
        requestConfig: {
          forceRequest: true,
          cancellable: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, this.endpoint)
      })
  }
}
